import C from 'actionTypes'

const defaultState = {
  isRedirected: false,
}

const redirection = (state = defaultState, action) => {
  const { data } = action

  switch (action.type) {
    case C.REDIRECTION:
      return {
        ...state,
        isRedirected: data,
      }
    default:
      return state
  }
}

export default redirection



// WEBPACK FOOTER //
// ./src/reducers/client/redirection.js